// @ts-nocheck

export const localeCodes =  [
  "fa"
]
export const localeLoaders = {
  fa: []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "fa",
    language: "fa-IR",
    dir: "rtl",
    domains: [],
    defaultForDomains: []
  }
]

